import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, NewspaperIcon, BookmarkIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const articles = [
  {
    title: 'Conflict Resolution 101 for startups',
    url: 'https://www.close.com/blog/conflict-resolution-101-for-startups'
  },
  {
    title: 'How to manage conflict in the workplace (Dropbox)',
    url: 'https://experience.dropbox.com/virtual-first-toolkit/communication/resolve-conflict-management'
  },
  {
    title: 'Conflict Management Canvass - FearlessCulture',
    url: 'https://www.fearlessculture.design/blog-posts/how-to-solve-conflict-with-the-conflict-management-canvas'
  },
  {
    title: 'Want collaboration? Accept—and actively manage—conflict (HBR)',
    url: 'https://hbr.org/2005/03/want-collaboration-accept-and-actively-manage-conflict'
  },
  {
    title: 'How to manage conflict in a startup (Entrepeneur India)',
    url: 'https://www.entrepreneur.com/en-in/leadership/what-causes-conflict-in-a-startup-and-how-to-resolve-it/305129'
  },
  {
    title: 'How to Solve Conflict Productively at Work | By Gustavo Razzetti',
    url: 'https://www.fearlessculture.design/blog-posts/how-to-solve-conflict-productively-at-work'
  },
  {
    title: 'Want to Resolve Conflicts? Use this Rule | By Gustavo Razzetti',
    url: 'https://www.fearlessculture.design/blog-posts/want-to-resolve-conflicts-use-this-rule'
  },
  {
    title: 'How to Have Difficult Conversations at Work Like an Optimist | By Gustavo Razzetti',
    url: 'https://www.fearlessculture.design/blog-posts/how-to-have-difficult-conversations-at-work-like-an-optimist'
  }
];

const tools = [
  {
    title: 'Non violent communication canvas [miro template]',
    url: 'https://miro.com/miroverse/nonviolent-communication-nvc-template/'
  },
  {
    title: 'Thomas Kilmann Conflict Management Model [pdf]',
    url: 'https://kilmanndiagnostics.com/wp-content/uploads/2018/03/TKI_Sample_Report.pdf'
  },
  {
    title: 'Thomas Kilmann Conflict Management Model deep dive',
    url: 'https://www.mtdtraining.com/blog/thomas-kilmann-conflict-management-model.htm'
  },
  {
    title: 'Liberating structures toolkit',
    url: 'https://www.liberatingstructures.com/'
  }
];

const guides = [
  {
    title: 'Conflict handling',
    url: 'https://www.notion.so/Conflict-handling-bd1de88dfbbb448d86c358c483f9b290'
  },
  {
    title: 'Conflict Resolution Guide',
    url: 'https://www.notion.so/Conflict-Resolution-Guide-7d4aa09b1adf4e72a8901f7295d77e92'
  },
  {
    title: 'Conflict Resolution Guidelines',
    url: 'https://www.notion.so/Conflict-Resolution-Guidelines-39edee0c846a43918320f74e4b60cbfb'
  },
  {
    title: 'Disagree & Commit at Levels (Levels)',
    url: 'https://www.notion.so/Disagree-Commit-at-Levels-Levels-30afb65b8ce747ada7525c7634b35d0f'
  }
];

const WorkingThroughConflictUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Articles" 
            items={articles} 
            icon={NewspaperIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Tools & Templates" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard className="lg:col-span-2">
          <ResourceList 
            title="Guides & Frameworks" 
            items={guides} 
            icon={BookmarkIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default WorkingThroughConflictUsefulResources; 